import React from "react";
import PropTypes from "prop-types";
import styles from "./FallbackAvatar.module.css";

const FallbackAvatar = ({ name, size = 40 }) => {
  const letter = name?.[0]?.toUpperCase() || "U";

  return (
    <div
      className={styles.avatar}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        fontSize: `${size * 0.5}px`,
      }}
    >
      {letter}
    </div>
  );
};

FallbackAvatar.propTypes = {
  name: PropTypes.string,
  size: PropTypes.number,
};

export default FallbackAvatar;
